import { TVehicle } from "types";

import { EnergyTypes, getEnergyType, isNeuwagen } from "./helper";

export type TQuality = {
  pictures: number;
  envkv: number;
  score: number;
};

export const checkQuality = (vehicle: TVehicle): TQuality => {
  const envkv = evaluteEnVKV(vehicle);
  const pictures = evaluatePictures(vehicle);

  const elements = [envkv, pictures];

  const score = envkv ? summarize(elements) / elements.length : 0;

  return { envkv, pictures, score };
};

const evaluteEnVKV = (vehicle: TVehicle): number => {
  const neuwagen = isNeuwagen(vehicle);
  const pkw = vehicle.aufbau_bereich.name === "PKW";
  if (!(neuwagen && pkw)) return 1;

  const energyType = getEnergyType(vehicle);

  let valid = true;
  switch (energyType) {
    case EnergyTypes.ELEKTRO:
      valid =
        checkDefined(vehicle.wltp_co2klasse) &&
        checkDefined(vehicle.wltp_co2_emissionen) &&
        checkDefined(vehicle.wltp_stromverbrauch_kombiniert) &&
        checkDefined(vehicle.wltp_stromverbrauch_langsam) &&
        checkDefined(vehicle.wltp_stromverbrauch_mittel) &&
        checkDefined(vehicle.wltp_stromverbrauch_schnell) &&
        checkDefined(vehicle.wltp_stromverbrauch_sehr_schnell);
      break;
    case EnergyTypes.VERBRENNER:
      valid =
        checkDefined(vehicle.wltp_co2klasse) &&
        checkDefined(vehicle.wltp_co2_emissionen) &&
        checkDefined(vehicle.wltp_kombiniert) &&
        checkDefined(vehicle.wltp_langsam) &&
        checkDefined(vehicle.wltp_mittel) &&
        checkDefined(vehicle.wltp_schnell) &&
        checkDefined(vehicle.wltp_sehr_schnell);
      break;
    case EnergyTypes.HYBRID:
      valid =
        checkDefined(vehicle.wltp_co2klasse) &&
        checkDefined(vehicle.wltp_co2klasse_entladen) &&
        checkDefined(vehicle.wltp_co2_emissionen) &&
        checkDefined(vehicle.wltp_co2_emissionen_entladen) &&
        checkDefined(
          vehicle.wltp_stromverbrauch_kombiniert_reiner_batteriebetrieb
        ) &&
        checkDefined(
          vehicle.wltp_stromverbrauch_langsam_reiner_batteriebetrieb
        ) &&
        checkDefined(
          vehicle.wltp_stromverbrauch_mittel_reiner_batteriebetrieb
        ) &&
        checkDefined(
          vehicle.wltp_stromverbrauch_schnell_reiner_batteriebetrieb
        ) &&
        checkDefined(
          vehicle.wltp_stromverbrauch_sehr_schnell_reiner_batteriebetrieb
        ) &&
        checkDefined(vehicle.wltp_kombiniert_entladen) &&
        checkDefined(vehicle.wltp_langsam_entladen) &&
        checkDefined(vehicle.wltp_mittel_entladen) &&
        checkDefined(vehicle.wltp_schnell_entladen) &&
        checkDefined(vehicle.wltp_sehr_schnell_entladen);
      break;
    case EnergyTypes.WASSERSTOFF:
      valid =
        checkDefined(vehicle.wltp_co2klasse) &&
        checkDefined(vehicle.wltp_co2_emissionen) &&
        checkDefined(vehicle.wltp_kombiniert) &&
        checkDefined(vehicle.wltp_langsam) &&
        checkDefined(vehicle.wltp_mittel) &&
        checkDefined(vehicle.wltp_schnell) &&
        checkDefined(vehicle.wltp_sehr_schnell);
      break;
    case EnergyTypes.ERDGAS:
      valid =
        checkDefined(vehicle.wltp_co2klasse) &&
        checkDefined(vehicle.wltp_co2_emissionen) &&
        checkDefined(vehicle.wltp_kombiniert) &&
        checkDefined(vehicle.wltp_langsam) &&
        checkDefined(vehicle.wltp_mittel) &&
        checkDefined(vehicle.wltp_schnell) &&
        checkDefined(vehicle.wltp_sehr_schnell);
      break;

    default:
      valid = true;
  }

  return valid ? 1 : 0;
};

const checkDefined = (value: any): boolean => {
  return !(value === undefined || value === null);
};

const evaluatePictures = (vehicle: TVehicle): number => {
  const count = vehicle.picturesCount;
  switch (true) {
    case count === 0:
      return 0;

    case count < 4:
      return count * 0.25;

    default:
      return 1;
  }
};

const summarize = (elements: number[]): number =>
  elements.reduce((a, e) => a + e, 0);
